import { Box, Button, CircularProgress, Grid, Grow, Pagination, Paper, Toolbar } from "@mui/material";
import ListAlbum from "./ListAlbum";
import clsx from "clsx";
import { t } from "i18next";
import { showAlbumModal } from "../../app/appSlice";
import session from "../../app/Session";
import AlbumCard from "./AlbumCard";
import { colors } from '../../Theme';
import styles from "./ListAlbum.module.css";
import { useEffect, useState } from "react";
import { get } from "http";
import { AlbumsService } from "../../api/services";
import { getService } from "../../app/api";
import { AlbumDto } from "../../api/models";
import { invalidate, setSelectedAlbumId } from "./ListAlbumSlice";
import { useAppDispatch } from "../../app/hooks";
import * as Media from '../media/mediaSlice'
import { useNavigate } from "react-router-dom";

export default function SharedAlbums() {
  let [invalidated, setInvalidated] = useState(true);
  let [page, setPage] = useState(1);
  let [pageSize, setPageSize] = useState(100);
  let [items, setItems] = useState<AlbumDto[]>([]);
  let [total, setTotal] = useState(0);
  let [totalPages, setTotalPages] = useState(0);
  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const token = session.getToken();

  function onView(albumId: string) {
    dispatch(setSelectedAlbumId(albumId));
    dispatch(Media.invalidate(true));
    dispatch(Media.setAlbumId({ albumId }));
    navigate(`/album/${albumId}`, { replace: true });
  }

  async function loadSharedAlbums(page: number, pageSize: number) {
    try {
      const response = await getService(AlbumsService).getSharedAlbums({ page, pageSize });
      setItems(response.items || []);
      setTotal(response.totalItems || 0);
      setTotalPages(response.totalPages);
      setInvalidated(false);
    } catch (error) {
      console.error("Error fetching shared albums:", error);
      setInvalidated(false);
    }
  }

  useEffect(() => {
    if (invalidated) {
     loadSharedAlbums(page, pageSize);
    }
  }, [invalidated]);

  const onPageChange = (page: number) => {
    setPage(page);
    setInvalidated(true);
  }

  return (
    <Grow
      in={true}
      style={{ transformOrigin: '0 0 0' }}
      timeout={{ enter: 500, exit: 500 }}
    >
      <div style={{ position: 'relative' }}>
        {invalidated === true && (
          <div className="progress-indicator">
            <CircularProgress size="5rem" />
          </div>
        )}
        <div className={invalidated === true ? 'content-loading' : undefined}>
          {totalPages > 1 &&
            (<Paper elevation={3} className="content-pagination">
              <Pagination count={totalPages} variant="outlined" color="primary" page={page} onChange={(e, page) => onPageChange(page)} />
            </Paper>
            )}

          <div id="image-list" className={styles.image_grid}>
            {items.map(item => <AlbumCard item={item} onView={onView} token={token} />)}
          </div>

          {totalPages > 1 &&
            (<Paper elevation={3} className="content-pagination">
              <Pagination count={totalPages} variant="outlined" color="primary" page={page} onChange={(e, page) => onPageChange(page)} />
            </Paper>
            )}
        </div>
      </div>
    </Grow>
  );
}